import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { CheckboxMatComponent } from './checkbox-mat/checkbox-mat.component';
import { CheckboxStoreComponent } from './checkbox-store/checkbox-store.component';
import { FilterCompanyComponent } from './filter-company/filter-company.component';
import { LargeSideFilterComponent } from './large-side-filter/large-side-filter.component';
import { SideFilterComponent } from './side-filter/side-filter.component';

@NgModule({
  declarations: [FilterCompanyComponent, CheckboxStoreComponent, LargeSideFilterComponent, CheckboxMatComponent, SideFilterComponent],
  exports: [FilterCompanyComponent, CheckboxStoreComponent, LargeSideFilterComponent, CheckboxMatComponent, SideFilterComponent],
  imports: [
    MatTooltipModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatTreeModule,
    MatIconModule,
    ReactiveFormsModule
  ],
})
export class FilterModule {}
